import React, { Dispatch, SetStateAction } from "react"

import { SlideIndex } from "../OnboardingScreen"

import { Slide1 } from "./Slide1"
import { Slide2 } from "./Slide2"

export const Slides = ({
  index,
  nextSlideAction,
  setBBOverride,
}: {
  index: 1 | 2
  nextSlideAction: React.Dispatch<React.SetStateAction<SlideIndex>>
  setBBOverride: Dispatch<SetStateAction<boolean>>
}) => {
  switch (index) {
    case 1:
      return <Slide1 nextSlideAction={nextSlideAction} />
    case 2:
      return <Slide2 setBBOverride={setBBOverride} />
  }
}
